import { HttpClient, HttpMethods } from "@planzone/services";
import { Identifiable, Organization, Planzone } from "@planzone/dto";

function updateOrganization(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    organization: Identifiable<Organization>,
    nextOrganization: Organization,
  ): Promise<Identifiable<Organization>> =>
    httpClient
      .sendHttpRequest<void>({
        data: nextOrganization,
        endpoint: `/api/organizations/${organization.uuid}`,
        method: HttpMethods.PATCH,
      })
      .then(() => ({ ...organization, ...nextOrganization }));
}

export { updateOrganization };
